import { JSX } from "react";

export class AdequacyDetailWaffleToppings {
  // The order of these property declarations must match the order of the columns in
  // AdequacyDetails.buildWaffleToppings() for compare mode to display properly
  // when one of the rows has no data.
  public key: string;
  public title: JSX.Element;
  public countyClass: string;
  public resultsFor: string;
  public regionName: string;
  public membershipName: JSX.Element;
  public fullMembershipCount: string;
  public maxReqdDistance: string;
  public maxReqdTime: string;
  public countySSA: string;
  public fullMemberCountWithAccess: string;
  public accessWith: string;
  public fullMemberCountWithoutAccess: string;
  public accessWithout: string;
  public accessAvgDist: string;
  public accessAvgDistWith: string;
  public accessAvgDistWithout: string;
  public accessAvgDist2: string;
  public accessAvgDist2With: string;
  public accessAvgDist2Without: string;
  public accessMaxDist: string;
  public accessMaxDistWith: string;
  public accessMaxDistWithout: string;
  public accessWithDist: string;
  public accessWithoutDist: string;
  public accessAvgTime: string;
  public accessAvgTimeWith: string;
  public accessAvgTimeWithout: string;
  public accessAvgTime2: string;
  public accessAvgTime2With: string;
  public accessAvgTime2Without: string;
  public accessMaxTime: string;
  public accessMaxTimeWith: string;
  public accessMaxTimeWithout: string;
  public accessWithTime: string;
  public accessWithoutTime: string;
  public accessMetDist: string;
  public accessMetTime: string;
  public accessMet: string;
  public accessTelehealthCredit: string;
  public conAccessCreditPercentage: string;
  public servicingRequired: string;
  public servicingProviderCount: string;
  public regionServicingCount: JSX.Element | string;
  public servicingDistinct: string;
  public servicingProviderToMemberRatio: string;
  public servicingMet: string;
  public overallMet: string;
  public overallGapAge: string;
  public marketAccess: string;
  public marketProviderCount: string;
  public marketDistinct: string;
  public marketPercentage: string;
  public prospectImpact: JSX.Element;
  public attestationPercent: string;
  public gapSharedInsights: string;
  public fillableGapIndicator: string;
  public gapFillStatus: string;
  public gapFillStatusUpdatedDate: string;
  public gapFillStatusUpdatedByName: string;
  public gapFillStatusComment: string;

  constructor(key: string, resultsFor: string) {
    this.key = key;
    this.title = null;
    this.countyClass = "---";
    this.resultsFor = resultsFor;
    this.regionName = "---";
    this.membershipName = null;
    this.fullMembershipCount = "---";
    this.maxReqdDistance = "---";
    this.maxReqdTime = "---";
    this.countySSA = "---";
    this.fullMemberCountWithAccess = "---";
    this.accessWith = "---";
    this.fullMemberCountWithoutAccess = "---";
    this.accessWithout = "---";
    this.accessAvgDist = "---";
    this.accessAvgDistWith = "---";
    this.accessAvgDistWithout = "---";
    this.accessAvgDist2 = "---";
    this.accessAvgDist2With = "---";
    this.accessAvgDist2Without = "---";
    this.accessMaxDist = "---";
    this.accessMaxDistWith = "---";
    this.accessMaxDistWithout = "---";
    this.accessWithDist = "---";
    this.accessWithoutDist = "---";
    this.accessAvgTime = "---";
    this.accessAvgTimeWith = "---";
    this.accessAvgTimeWithout = "---";
    this.accessAvgTime2 = "---";
    this.accessAvgTime2With = "---";
    this.accessAvgTime2Without = "---";
    this.accessMaxTime = "---";
    this.accessMaxTimeWith = "---";
    this.accessMaxTimeWithout = "---";
    this.accessWithTime = "---";
    this.accessWithoutTime = "---";
    this.accessMetDist = "---";
    this.accessMetTime = "---";
    this.accessMet = "---";
    this.accessTelehealthCredit = "---";
    this.conAccessCreditPercentage = "---";
    this.servicingRequired = "---";
    this.servicingProviderCount = "---";
    this.regionServicingCount = "---";
    this.servicingProviderToMemberRatio = "---";
    this.servicingDistinct = "---";
    this.servicingMet = "---";
    this.overallMet = "---";
    this.overallGapAge = "---";
    this.marketAccess = "---";
    this.marketProviderCount = "---";
    this.marketDistinct = "---";
    this.marketPercentage = "---";
    this.gapSharedInsights = "---";
    this.fillableGapIndicator = "";
    this.prospectImpact = <span key="0" />;
    this.attestationPercent = "---";
    this.gapFillStatus = "---";
    this.gapFillStatusUpdatedDate = "---";
    this.gapFillStatusUpdatedByName = "---";
    this.gapFillStatusComment = "---";
  }
};
